import React from 'react';

import Icon from 'components/icon/icon'

const AlertBanner = props => {
    const {
        title,
        body,
        low
    } = props

    return (
        <div className={low ? "alert-banner low" : "alert-banner"}>
            <div className="icon-container">
                <Icon name="fe-flag" />
            </div>
            <h2>
                { title }
            </h2>
            { typeof body === 'string' ?
                <span dangerouslySetInnerHTML={{ __html: body }} />
            :
                <span>
                    { body }
                </span>
            }
        </div>
    )
};

export default AlertBanner


// WEBPACK FOOTER //
// ./src/components/alerts/alert-banner.jsx